import { api } from "./configs/AxiosConfigs"
import { defineCancelApiObject } from "./configs/AxiosUtils"

import config from '../config/client.json'

export const ApiKeyAPI = {
    getList: async function (props, cancel = false) {
        props.store.setLoadingBarStatus(false)
        const response = await api.request({
            url: `${config.serviceUrl}/apikey`,
            method: "GET",
            headers: { 'Authorization': "Bearer " + props.store.token, 'Content-Type': "application/json" },
            data: null,
            signal: cancel ? cancelApiObject[this.getList.name].handleRequestCancellation().signal : undefined,
        })
        props.store.setLoadingBarStatus(true)
        return response.data
    },
    create: async function (props, apikey, cancel = false) {
        props.store.setLoadingBarStatus(false)
        const response = await api.request({
            url: `${config.serviceUrl}/apikey/`,
            method: "POST",
            headers: { 'Authorization': "Bearer " + props.store.token, 'Content-Type': "application/json" },
            data: apikey,
            signal: cancel ? cancelApiObject[this.create.name].handleRequestCancellation().signal : undefined,
        })
        props.store.setLoadingBarStatus(true)
        return response.data
    },
    delete: async function (props, id, cancel = false) {
        props.store.setLoadingBarStatus(false)
        const response = await api.request({
            url: `${config.serviceUrl}/apikey/${id}`,
            method: "DELETE",
            headers: { 'Authorization': "Bearer " + props.store.token, 'Content-Type': "application/json" },
            signal: cancel ? cancelApiObject[this.delete.name].handleRequestCancellation().signal : undefined,
        })
        props.store.setLoadingBarStatus(true)
        return response.data
    },
}

// defining the cancel API object for ProductAPI
const cancelApiObject = defineCancelApiObject(ApiKeyAPI) 